import React from 'react';
import { APP_VERSION } from '../constants';

const Footer = () => {
    return (
        <footer style={{
            padding: '10px 20px',
            textAlign: 'center',
            borderTop: '1px solid #333',
            color: '#666',
            fontSize: '0.8rem',
            marginTop: 'auto'
        }}>
            <p>MIDISeek {APP_VERSION} | Generative Music Architecture | Made by Sounds by Shawn</p>
        </footer>
    );
};

export default Footer;